import { Component, ChangeDetectionStrategy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ImageItem } from 'ng-gallery';
import { Image, LightboxService } from "ngx-photoswipe";
import { ProjectsService } from '../services/projects.service';
declare var jQuery: any;
// import 'lg-zoom.js';
// import 'lg-share.js';

@Component({
  selector: 'app-work',
  templateUrl: './work.component.html',
  styleUrls: ['./work.component.scss']
})
export class WorkComponent implements OnInit {
  title = '';
  description = '';

  id: any;
  imageData: any=[];
  items: any = [];

    constructor(
      private route: ActivatedRoute,
      private projectService: ProjectsService
    ) {}

  ngOnInit() {

    this.id = this.route.snapshot.paramMap.get('id');

    this.projectService.getImages(this.id).subscribe( e => {
        this.imageData = e;
        this.imageData.forEach(element => {
            this.items.push({src: `../../assets/images/uploads/${element.image}`});
        });

        this.projectService.getProject(this.id).subscribe( res => {
          this.title = res[0].name;
          this.description = res[0].description;

          document.getElementById('dynamic').addEventListener('click', () => {
            lightGallery(document.getElementById('dynamic'), {
              dynamic: true,
              download: true,
              dynamicEl: this.items
            });
          })

          lightGallery(document.getElementById('lightgallery'), {
            actualSize: false
          });
          $( document ).ready(function() {
            console.log( "ready!" );
            document.getElementById('reini').click();
        });
          console.log("EXECUTED");
        });


    

    });
  }

  reini() {
    lightGallery(document.getElementById('lightgallery'), {
      actualSize: false
    });
  }
}



//   items: GalleryItem[];

//   id: any;
//   imageData: any= [];
//   project_name: any;

//   constructor(
//     public gallery: Gallery, 
//     public lightbox: Lightbox,  
//     private route: ActivatedRoute,
//     private projectService: ProjectsService
//     ) {}


//   ngOnInit() {
//     this.id = this.route.snapshot.paramMap.get('id');

//     this.projectService.getProject(this.id).subscribe( res => {
//       this.project_name = res[0].name;
//     });

//       this.projectService.getImages(this.id).subscribe( res => {
  
//         this.imageData = res;

//         this.items = this.imageData.map(item => new ImageItem({ src: item.image }));
//         const lightboxRef = this.gallery.ref('lightbox');
//         lightboxRef.setConfig({
//           imageSize: ImageSize.Cover,
//           thumbPosition: ThumbnailsPosition.Top,
//         });
//         lightboxRef.load(this.items);
    
//       });
//   }

// }